import React from "react";
import { Grid } from "@material-ui/core";
import { useState, useEffect } from "react";

// components
import PageTitle from "../../components/PageTitle";

import MetricsGraph from "./Ethics/Metrics";

export default function TabView() {
  const [spinner, setSpinner] = React.useState(false);
  const [algoName, setAlgoname] = useState([]);
  const [customValue, setCustomValue] = useState({});
  const [currentAlgo, setCurrentAlgo] = useState("");
  const [dateList, setDateList] = useState([]);
  const [loadList, setLoadlist] = useState(null);


  useEffect(() => {
    sessionStorage.removeItem("MODULE_DATA");
    initValue(null);
  }, [customValue]);


  // console.log(customValue,"Object.keys(customValue).length");
  const initValue = async (params) => {
    // Intersect()
    setSpinner(true);
    let metricsList = {};
    let tempOverall = [];
    let dates = [];

    // if (sessionStorage.getItem("currentModelName")) {
    let URL;
    if (loadList != "proxy") {
      //  URL = (sessionStorage.getItem("currentModelName")==="Credit Lending") ? "algoList" : {};

      URL =
        sessionStorage.getItem("currentModelName")==="Credit Lending"
          ? "algoList"
          : sessionStorage.getItem("currentModelName")==="Fraud Detection"
          ? "child_fraud_algoList"
          : "algoList";
    } else {
      URL =
        sessionStorage.getItem("currentModelName")==="Credit Lending"
          ? "proxy"
          : sessionStorage.getItem("currentModelName")==="Fraud Detection"
          ? "child_fraud_proxy"
          : "proxy";
    }
    // alert(URL)
    // console.log(URL)
    fetch(process.env.PUBLIC_URL + `/test/${URL}.json`)
      .then(function (res) {
        return res.json();
      })
      .then(function (selectedAlgo) {
        if (selectedAlgo && Object.keys(selectedAlgo).length) {
          selectedAlgo[Object.keys(selectedAlgo)[0]].map(
            (metricsData) => (tempOverall = [...tempOverall, metricsData.algo])
          );
          selectedAlgo &&
            Object.keys(selectedAlgo).map((date) =>
              dates.push(new Date(date * 1000).toLocaleDateString("en-US"))
            );

          setAlgoname(tempOverall);
          setCurrentAlgo(tempOverall[0]);
          setDateList(dates);
          // console.log(selectedAlgo[Object.keys(selectedAlgo)[0]],"algoName",algoName)
          selectedAlgo &&
            Object.keys(selectedAlgo).length &&
            Object.values(selectedAlgo).map((metricsDataList) => {
              metricsDataList &&
                metricsDataList.map((metricsData) => {
                  // console.log("algo: ", metricsData.algo)
                  if (!(metricsData.algo in metricsList))
                    metricsList[metricsData.algo] = {};
                  Object.keys(metricsData.metrics).map((metric) => {
                    if (metric in metricsList[metricsData.algo]) {
                      metricsList[metricsData.algo][metric].push(
                        metricsData.metrics[metric]
                      );
                    } else
                      metricsList[metricsData.algo][metric] = [
                        metricsData.metrics[metric],
                      ];
                  });
                });
            });
        }
        // console.log(Object.keys(customValue).length,loadList)
        if (customValue && Object.keys(customValue).length===0)
          setCustomValue(metricsList);

        setTimeout(function () {
          setSpinner(false);
        }, 3000);
      })
      .catch(function (err) {
        setSpinner(false);
        console.log(err, " error");
      });
    // }
  };
  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  return (
    <>
      {algoName.length > 0 && currentAlgo && (
        <PageTitle
          title="Bias Metrics"
          data={algoName}
          width={["0.5", "0.5"]}
          dropDownName="Mitigation Algorithm"
          initialData={currentAlgo}
          selectValue={(data) => {
            setCurrentAlgo(data);
          }}
        />
      )}

      <div>
        <Grid container spacing={2}>
          {customValue &&
            Object.keys(customValue).length > 0 &&
            customValue[currentAlgo] &&
            Object.keys(customValue[currentAlgo]).map((metric) => (
              <Grid item md={6} lg={6} sm={6}>
              <MetricsGraph
                name={metric}
                algo={currentAlgo}
                data={customValue[currentAlgo][metric]}
                dates={dateList}
              />
              </Grid>
            ))}
        </Grid>
      </div>
      <br />
    </>
  );
}
